import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(HttpApi)
  .init({
    backend: {
      loadPath: `/${process.env.REACT_APP_I18N_FOLDER}/locale/{{lng}}.json`,
    },
    fallbackLng: "de",
    nonExplicitSupportedLngs: true,
    detection: {
      lookupLocalStorage: "lang", // name of the variable in localstorage
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // load: "languageOnly",
  });

export default i18n;
